export enum RoleEnum {
    ADMIN = 'ADMIN',
    HR = 'HR',
    USER = 'USER'
}

export enum NavDropdownItemsEnum {
    RECRUITMENT_SETTINGS = 'RECRUITMENT_SETTINGS',
    COMPANY_PROFILE = 'COMPANY_PROFILE',
    TEAM_MANAGEMENT = 'TEAM_MANAGEMENT',
    LOCATIONS = 'LOCATIONS',
    BILLING_AND_INVOICES = 'BILLING_AND_INVOICES',
    WHATSAPP_TEMPLATES = 'WHATSAPP_TEMPLATES',
    INTERVIEW_LOCATIONS = 'INTERVIEW_LOCATIONS',
    SAUD_CONFIGURATION = 'SAUD_CONFIGURATION',
    WHATSAPP_SETUP = 'WHATSAPP_SETUP',
}

export enum PartnerUserStatusEnum {
    INVITED = 'INVITED',
    ACTIVE = 'ACTIVE',
}

export enum InvitationStringType {
    MOBILE = 'MOBILE',
    EMAIL = 'EMAIL',
}

export enum LocationPostingStatus {
    POSTING = 'POSTING',
    POSTED = 'POSTED',
    FAILED = 'FAILED',
}